// TODO: IMP TO BE REFACTORED TO CHANGE NAMING AND BETTER SEPARATION OF CONCERNS
import {
  getVariants,
  adjustColor,
  contrastRatio,
  ensureContrast,
  withOpacity,
} from '../utils/colorUtilities'

const baseColors = {
  sidebar: '#043850',
  sidebarHover: '#032d3d',
  neutrals500: '#898384',
  navigationLinksDefault: '#ffffff',
  cardBorder: '#137FC3',
  white: '#ffffff',
  darkPurple: '#3C3A55',
  inputField: '#495057',
  defaultDisabledBorderColor: '#CED4DA',
  boxShadow: '#12263f08',
  dropdownBoxShadow: '#00000024',
  gray50: '#f9fafb',
  gray300: '#b3bbd3',
  gray400: '#9ca3af',
  gray500: '#6b7280',
  gray600: '#4b5563',
  gray700: '#374151',
  gray800: '#1f2937',
  headersMiniTitle: '#076698',
  headerItemColor: '#555b6d',
  whiteSmoke: '#F8F8F8',
  headerItemColorHover: '#7b839c',
  hintsNotifications: '#3D3F46',
  tapNormal: '#3D3F46',
  tapBackgroundActive: '#BFD7E4',
  tapColorActive: '#076698',
  footerBg: '#f2f2f5',
  footerSpanColor: '#74788d',
  mainContentBg: '#f8f8fb',
  brandColorOrange: '#076698',
  brandColorLightOrange: '#137FC3',
  logoFill: '#81D0F9',
  paleBrandColor: '#A6B0CF',
  brandColorCreamy: '#BBCCD8',
  success: '#17B179',
  danger: '#DB504A',
  darkRed: '#A93C38',
  deepRed: '#7E2C2C',
  warning: '#ffc302',
  info: '#00A9E6',
  orange: '#ff8f00',
  green: '#134946',
  black: '#212529',
  warningText: '#725608',
  brightGray: '#E5EAEF',
  neutrals: '#5A5555',
  slateGray: '#7A858C',
  sandyBrown: '#FBA35C',
  salemGreen: '#0D8653',
  darkCerulean: '#0C5072',
  baseWhite: '#FAFAFA',
  dimGray: '#616A70',
  yellow: '#EEBA56',
  fadedYellow: '#EEBA5626',
  water: '#D5EFFD',
  ateneoBlue: '#054465',
  lightAteneoBlue: '#044866',
  babyBlue: '#ABE0FB',
  grey: '#514E5C',
  seaweed: '#283923',
  faluRed: '#8D1713FA',
  persianBlue: '#3429c3fa',
  appleRed: '#ff0d0d',
  blue: '#000cff',
  tertiary: '#A0B8C9',
  hoverBtn: '#404a5b',
  inactive: '#8A8A8A',
  sideNavBg: '#556EE619',
  deselected: '#666',
  circleRatingBg: '#0056b3',
  circleRatingDeselectedBg: '#e0e0e0',
  header: '#ffffff',
  localeTextColor: '#076698',
  defaultIconColor: '#5A5555',
  collapseSidebarBtn: '#555b6d',
  steelBlue: '#3885AC',
  blueSapphire: '#065A7F',
  paleCerulean: '#9CC1D5',
  prussianBlue: '#02364C',
  electricBlue: '#065b8e',
  lightWater: '#c9e7f5',
  celestialBlue: '#4a9abd',
  tuftsBlue: '#4a90e2',
  logoNav: '#ffffff',
  collapsedLogoPrimary: '#076698',
  collapsedLogoSecondary: '#81D0F9',

  calendarColors: {
    personal: '#34c759',
    google: '#4285f4',
    googleHoliday: '#ef4444',
    outlook: '#0078d4',
  },

  budgetCategoryColors: {
    salary: '#2563eb',
    taxes_insurance: '#0891b2',
    benefits: '#db2777',
    bonuses: '#ca8a04',
    recruitment: '#16a34a',
    training: '#9333ea',
    equipment: '#ea580c',
    overhead: '#dc2626',
    contingency: '#475569',
  },

  // Semantic status colors
  successColor: '#28a745',
  dangerColor: '#dc3545',
  neutralColor: '#9E9E9E',
  backgroundSecondary: '#f0f4f8',
  textSecondary: '#6b7280',
  borderColor: '#E0E0E0',

  // AI Insight card colors
  aiInsightBg: '#FFFBF0',
  aiInsightBorder: '#FDE68A',
  aiInsightTitleColor: '#92400E',
  aiInsightBodyColor: '#78350F',
  aiInsightIconStroke: '#EB781A',

  // Quality badge colors
  qualityExcellentBg: '#E8F5E9',
  qualityExcellentText: '#2E7D32',
  qualityGoodBg: '#E3F2FD',
  qualityGoodText: '#1565C0',
  qualityAverageBg: '#FFF8E1',
  qualityAverageText: '#F57F17',
  qualityDefaultBg: '#F5F5F5',
  qualityDefaultText: '#616161',

  // Chart palette colors
  chartPrimary: '#137FC3',
  chartPrimaryAlpha: 'rgba(19, 127, 195, 0.1)',
  chartSecondary: '#c08600',
  chartSecondaryAlpha: 'rgba(192, 134, 0, 0.1)',
  chartGreen: '#4a9c42',
  chartDark: '#1B2B4B',
  // Radar overlays, ordered for maximum separation between any two rings (the
  // slots come from CHART_COLORS in features/reports/config/reportStyles.js).
  // Note: no five hues can be told apart under deuteranopia when they overlap,
  // so radar leans on its legend and axis labels as the secondary encoding —
  // more than ~3 rings wants small multiples, not more colors.
  chartRadarColors: [
    { border: '#076698', bg: 'rgba(7,102,152,0.15)' },
    { border: '#0090b7', bg: 'rgba(0,144,183,0.15)' },
    { border: '#b94642', bg: 'rgba(185,70,66,0.15)' },
    { border: '#c08600', bg: 'rgba(192,134,0,0.15)' },
    { border: '#008a74', bg: 'rgba(0,138,116,0.15)' },
  ],

  accentColor: '#076698',
  accentMutedColor: 'rgba(7,102,152,0.06)',
  textPrimary: '#1f2937',
  textMuted: '#6b7280',
  borderMuted: '#e5e7eb',
  panelBackground: '#f8fafc',
  surfaceMuted: '#f8f9fa',
  gridLineColor: 'rgba(0,0,0,0.05)',
  positiveColor: '#16a34a',
  negativeColor: '#dc2626',
  warningColor: '#e65100',
  positiveBackground: '#dcfce7',
  negativeBackground: '#fee2e2',
  plannedColor: '#1565c0',
  plannedBackground: '#e3f2fd',
  onHoldBackground: '#fff3e0',
  delayedBackground: '#fce4ec',
  neutralText: '#616161',
  neutralBackground: '#f5f5f5',
  linkText: '#3b82f6',
  positiveRowBackground: '#f0fdf4',
  negativeRowBackground: '#fef2f2',
  baseMetricColor: '#1e3a5f',
  chartBarPrimary: '#2d4a6d',
  chartBarSelected: '#1e3a5c',
  chartBarHover: '#3d6178',
  chartLineMuted: '#94a3b8',
  chartLineDark: '#475569',
  chartLineDarkFill: 'rgba(71, 85, 105, 0.12)',
  chartLineMutedFill: 'rgba(148,163,184,0.15)',
  chartLinePrimaryFill: 'rgba(45,74,109,0.12)',
  donutPalette: [
    '#2d4a6d',
    '#34495e',
    '#1e3a5c',
    '#2c526a',
    '#3d6178',
    '#4d7285',
    '#617f8c',
    '#7a929a',
    '#adb5bd',
  ],
  // Interview / document upload / dropzone palette
  talentinoWhiteBlue: '#E5EAEF',
  talentinoDarkerWhiteBlue: '#C4CFD4',
  talentinoSpecialBlue: '#076698',
  talentinoLightBackground: '#F8FBFD',
  talentinoLightBlueBackground: '#E5F3FF',
  talentinoSkyBlue: '#F1F5FA',
  talentinoBlue: '#137FC3',
  talentinoBlack: '#000000',
  talentinoSecondaryGray: '#6B7280',
  talentinoTextGray: '#4B5563',
  talentinoRed: '#A93C38',

  // Composite backgrounds
  defaultBackground: '#ffffff  0% 0% no-repeat padding-box',
  whiteButtonBackground: '#f5f5f5 0% 0% no-repeat padding-box',
  gradientBackground:
    'transparent linear-gradient(0deg, #3927514D 0%, #80808000 100%) 0% 0% no-repeat padding-box',

  costStackPalette: [
    '#4e79a7',
    '#76b7b2',
    '#59a14f',
    '#edc948',
    '#f28e2b',
    '#b07aa1',
    '#e15759',
    '#9c755f',
    '#bab0ac',
    '#76b7b2',
  ],
}

export const baseLayout = {
  sidebarCollapsedWidth: '4.375rem',
  sidebarWidth: '16rem',
  sidebarWidthSm: '4.375rem',
  headerHeight: '3.750rem',
  mobileBreakpoint: 800,
  mobileHeaderHeight: '6.5rem',
  mobileHeaderTopRowHeight: '3.375rem',
  mobileHeaderBottomRowHeight: '3.125rem',
  footerHeight: '2.625rem',
  gridGutterWidth: '1.5rem',
  menuItemSpacing: '1rem',
}

export const baseTypography = {
  defaultFontSize: '0.8125rem',
}

export const createTheme = (customColor = null) => {
  const isDefaultBrand =
    !customColor || customColor === baseColors.brandColorOrange
  const { light, dark, extraDark } = getVariants(customColor)

  const isLightCustomColor =
    !isDefaultBrand && contrastRatio(customColor, '#ffffff') < 4.5

  const sidebarTextColor = isLightCustomColor ? '#1f2937' : '#ffffff'

  const sidebarSectionTitleColor = isLightCustomColor
    ? '#1f2937'
    : baseColors.babyBlue

  const headerSafeTextColor = isLightCustomColor
    ? baseColors.headerItemColor
    : customColor

  const buttonTextColor = isLightCustomColor ? '#1f2937' : '#ffffff'

  const textOnLightColor = isLightCustomColor
    ? ensureContrast(customColor, '#ffffff', 4.5)
    : customColor

  const tabActiveTextColor = isLightCustomColor ? '#1f2937' : customColor

  const brandCreamy = isDefaultBrand
    ? baseColors.brandColorCreamy
    : isLightCustomColor
      ? ensureContrast(adjustColor(customColor, 40), '#ffffff', 3.0)
      : adjustColor(customColor, 60)

  const brandColor = isDefaultBrand ? baseColors.brandColorOrange : customColor

  return {
    ...baseLayout,
    ...baseTypography,
    ...baseColors,
    brandColorOrange: brandColor,
    brandColorOrange15: withOpacity(brandColor, 15),
    brandColorOrange10: withOpacity(brandColor, 10),
    brandColorLightOrange: isDefaultBrand
      ? baseColors.brandColorLightOrange
      : light,
    headersMiniTitle: isDefaultBrand
      ? baseColors.headersMiniTitle
      : customColor,
    accentColor: isDefaultBrand ? baseColors.accentColor : customColor,
    accentMutedColor: isDefaultBrand
      ? baseColors.accentMutedColor
      : `${customColor}0F`,
    chartBarPrimary: isDefaultBrand ? baseColors.chartBarPrimary : customColor,
    chartBarSelected: isDefaultBrand ? baseColors.chartBarSelected : dark,
    chartBarHover: isDefaultBrand ? baseColors.chartBarHover : light,
    chartLinePrimaryFill: isDefaultBrand
      ? baseColors.chartLinePrimaryFill
      : `${customColor}1F`,
    donutPalette: isDefaultBrand
      ? baseColors.donutPalette
      : [
          customColor,
          dark,
          extraDark,
          light,
          baseColors.gray600,
          baseColors.gray500,
          baseColors.gray400,
          baseColors.gray300,
          baseColors.defaultDisabledBorderColor,
        ],
    tapColorActive: isDefaultBrand ? baseColors.tapColorActive : customColor,
    ateneoBlue: isDefaultBrand ? baseColors.ateneoBlue : customColor,
    logoFill: isDefaultBrand ? baseColors.logoFill : light,
    sidebar: isDefaultBrand ? baseColors.sidebar : dark,
    sidebarHover: isDefaultBrand ? baseColors.sidebarHover : extraDark,

    // header: isDefaultBrand ? baseColors.header : customColor,
    localeTextColor: isDefaultBrand ? baseColors.localeTextColor : customColor,
    // defaultIconColor: isDefaultBrand
    //   ? baseColors.defaultIconColor
    //   : baseColors.white,
    collapseSidebarBtn: isDefaultBrand
      ? baseColors.collapseSidebarBtn
      : customColor,

    darkCerulean: isDefaultBrand ? baseColors.darkCerulean : light,
    steelBlue: isDefaultBrand
      ? baseColors.steelBlue
      : adjustColor(customColor, -25),
    blueSapphire: isDefaultBrand ? baseColors.blueSapphire : light,
    babyBlue: isDefaultBrand ? baseColors.babyBlue : dark,

    paleCerulean: isDefaultBrand
      ? baseColors.paleCerulean
      : adjustColor(customColor, 60),
    prussianBlue: isDefaultBrand ? baseColors.prussianBlue : dark,
    electricBlue: isDefaultBrand
      ? baseColors.electricBlue
      : adjustColor(customColor, -20),
    cardBorder: isDefaultBrand ? baseColors.electricBlue : customColor,
    tapBackgroundActive: isDefaultBrand
      ? baseColors.tapBackgroundActive
      : baseColors.brightGray,
    brandColorCreamy: brandCreamy,

    lightWater: isDefaultBrand ? baseColors.lightWater : baseColors.brightGray,
    celestialBlue: isDefaultBrand ? baseColors.celestialBlue : customColor,
    circleRatingBg: isDefaultBrand ? baseColors.circleRatingBg : dark,
    tuftsBlue: isDefaultBrand
      ? baseColors.tuftsBlue
      : adjustColor(customColor, 10),

    lightAteneoBlue: isDefaultBrand ? baseColors.lightAteneoBlue : customColor,
    // logoNav: isDefaultBrand ? baseColors.logoNav : customColor,
    collapsedLogoPrimary: isDefaultBrand
      ? baseColors.collapsedLogoPrimary
      : customColor,
    collapsedLogoSecondary: isDefaultBrand
      ? baseColors.collapsedLogoSecondary
      : light,

    isLightCustomColor,
    sidebarTextColor,
    sidebarSectionTitleColor,
    headerSafeTextColor,
    buttonTextColor,
    textOnLightColor,
    tabActiveTextColor,
    tabActiveBorder: isLightCustomColor ? `3px solid ${customColor}` : 'none',
  }
}

const theme = createTheme()
export default theme
